import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import { PageHeader } from '@/app/shell'
import { Card, EmptyState, Skeleton } from '@/ui/primitives'
import { lei } from '@/lib/money'

type Stadiu = {
  stage: { id: number; name: string; color: string | null; probability: number
    is_won: boolean; is_lost: boolean }
  leads: { id: number; name?: string | null; client_name?: string | null
    estimated_value?: number | null; currency?: string | null }[] | null
  total_value?: number
}
type Board = { board: Stadiu[]; summary: { total_leads: number; total_weighted_value: number } }

export function Crm() {
  const { data, isPending } = useQuery({ queryKey: ['crm'], queryFn: () => api.get<Board>('/crm/pipeline/board') })

  return (
    <>
      <PageHeader
        title="Oportunitati"
        count={data ? `${data.summary.total_leads} in lucru · ${lei(data.summary.total_weighted_value)} lei ponderat` : undefined}
      />
      <div className="px-8 py-6">
        {isPending ? <Card><Skeleton rows={4} /></Card>
        : data && data.summary.total_leads === 0 ? (
          <Card>
            <EmptyState
              title="Nicio oportunitate in lucru"
              hint={`Fluxul are ${data.board.length} etape configurate, dar nu s-a introdus nimic in el inca.`}
            />
          </Card>
        ) : (
          <div className="flex gap-4 overflow-x-auto pb-2">
            {(data?.board ?? []).map((c) => (
              <div key={c.stage.id} className="w-64 shrink-0">
                <div className="flex items-center gap-2 mb-2 px-1">
                  <span className="w-2 h-2 rounded-full" style={{ background: c.stage.color ?? 'var(--color-muted)' }} />
                  <span className="text-[13px] font-medium">{c.stage.name}</span>
                  <span className="ml-auto text-[12px] text-muted tnum">{(c.leads ?? []).length}</span>
                </div>
                <div className="space-y-2">
                  {(c.leads ?? []).map((l) => (
                    <Card key={l.id} className="p-3">
                      <p className="text-[14px] font-medium truncate">{l.client_name ?? l.name ?? 'fara nume'}</p>
                      {l.estimated_value ? (
                        <p className="text-[13px] text-muted tnum mt-1">
                          {lei(l.estimated_value)} {l.currency ?? 'lei'}
                        </p>
                      ) : null}
                    </Card>
                  ))}
                  {(c.leads ?? []).length === 0 && (
                    <div className="rounded-[var(--radius-card)] border border-dashed border-line p-3 text-[12.5px] text-muted">
                      gol
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
